module.exports = __webpack_public_path__ + "static/media/mn.b2185c1f.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/mn.svg
// module id = 887
// module chunks = 0